package com.wintermar.inspection.feature.util.answer_type

import androidx.compose.ui.graphics.Color
import org.jetbrains.compose.resources.DrawableResource

data class AnswerTypeContentModel(
    val iconColor: Color,
    val icon: DrawableResource,
    val label: String
)
